import React, { Component } from "react";
import TitleWithControl from "../../ComponentsPedidos/TitleWithControl";
import ButtonContinue from "../../ComponentsPedidos/ButtonContinue";
import { ListaClientes } from "../../../../services/api";
import Modal, { ModalParceiro } from "../../Modals";
import $ from "jquery";
import { Box, Center, Input, InputGroup, InputLeftAddon, Tag, TagLabel } from "@chakra-ui/react";
import {
  BillingShippingContainer,
  BillingShippingContentContainer,
  BillingShippingContentContainerContent,
  BillingShippingContentContainerContentShipping,
  BillingShippingContentContainerContentShippingResume,
  BillingShippingContentContainerContentShippingResumeContent,
} from "./styles";

class BillingShipping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_product: this.props.data_request,
      data_delivery: this.props.data_delivery,
      data_proposal: this.props.data_proposal,
      cotacao_frete: [],
      shipping_value: [],
      total_value: 0,

      view_modal_shipping: false,
      index_request: this.props.index_request,
    };
  }

  componentDidMount() {
    var total_value = this.state.total_value;
    this.state.data_product.map((item) => {
      if (item.tipo_produto == "PROD") {
        total_value =
          Math.round(parseFloat(item.valor_total) * 100) / 100 + total_value;
      }
    });
    this.setState({ total_value: total_value });
    this.getFreightQuote();
  }

  getFreightQuote = async (e) => {
    try {
      var cep = this.state.data_delivery.cep;

      // var CEP_API = await fetch(`https://ws.apicep.com/cep/000000000.json`);
      // var CEP_API = await fetch(`https://ws.apicep.com/cep/`+cep+`.json`);
      var CEP_API = await fetch(`https://viacep.com.br/ws/${cep.trim()}/json/`);
      var CEP_API_REST = await CEP_API.json();
      var cidade = CEP_API_REST.city;
      var endereco =
        CEP_API_REST.logradouro +
        " - " +
        CEP_API_REST.bairro +
        ", " +
        CEP_API_REST.localidade +
        " - " +
        CEP_API_REST.uf +
        ", " +
        CEP_API_REST.cep;

      var myInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: "rodrigo@innovationbrindes.com.br",
          password: "123456",
        }),
        cors: "none",
        cache: "default",
      };

      var CARGO_API = await fetch(`https://api.cargobr.com/v1/auth/`, myInit);
      var CARGO_API_REST = await CARGO_API.json();

      var volumes = [];
      if (CARGO_API_REST.access_token != "") {
        var id_prazo_entrega = 0;
        this.state.data_product.map((item) => {
          if (parseInt(item.id_prazo_entrega) >= id_prazo_entrega) {
            id_prazo_entrega = parseInt(item.id_prazo_entrega);
          }
          if (item.tipo_produto == "PROD") {
            if (item.dados_embalagem != undefined) {
              volumes.push({
                width: parseInt(item.cubagem_embalagem.Largura) / 100,
                height: parseInt(item.cubagem_embalagem.Altura) / 100,
                length: parseInt(item.cubagem_embalagem.Comprimento) / 100,
                weight:
                  parseFloat(item.cubagem_embalagem.PesoCaixa) == 0
                    ? 1
                    : parseFloat(item.cubagem_embalagem.PesoCaixa),
                value:
                  Math.round(
                    ((parseFloat(item.valor_total) +
                      parseFloat(
                        item.codigo_impressao_embalagem_selecionada.valor.replace(
                          ",",
                          "."
                        )
                      ) *
                        parseFloat(item.qtd_negociada)) /
                      parseInt(item.cubagem_embalagem.QtdCaixa)) *
                      100
                  ) / 100,
                amount: parseInt(item.cubagem_embalagem.QtdCaixa),
                object_types: ["sobconsulta"],
              });
            } else {
              volumes.push({
                width: parseInt(item.Largura) / 100,
                height: parseInt(item.Altura) / 100,
                length: parseInt(item.Comprimento) / 100,
                weight:
                  parseFloat(item.PesoCaixa) == 0
                    ? 1
                    : parseFloat(item.PesoCaixa),
                value: parseFloat(item.CubagemTotal),
                amount: parseInt(item.QtdCaixa),
                object_types: ["sobconsulta"],
              });
            }
          }
        });
      }

      var myInit = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + CARGO_API_REST.access_token,
        },
        body: JSON.stringify({
          origin_zipcode: "02285020",
          destination_zipcode: cep,
          volumes: volumes,
        }),
        cors: "none",
        cache: "default",
      };

      var CARGO_TRANS_API = await fetch(
        `https://api.cargobr.com/v1/freights/quotations/`,
        myInit
      );
      var CARGO_TRANS_API_REST = await CARGO_TRANS_API.json();

      var cotacao = [];
      for (var transportadora of CARGO_TRANS_API_REST.options) {
        cotacao.push({
          name: transportadora.company.name,
          prazo_producao: id_prazo_entrega,
          max: transportadora.delivery_time.max + 1,
          min: transportadora.delivery_time.min + 1,
          price: parseFloat(
            parseFloat(transportadora.price) * 1.35
          ).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
        });
      }

      cotacao.sort(function (a, b) {
        if (a.price > b.price) {
          return 1;
        }
        if (a.price < b.price) {
          return -1;
        }
      });

      var cotacao_barato = cotacao[0];

      cotacao.sort(function (a, b) {
        if (a.max > b.max) {
          return 1;
        }
        if (a.max < b.max) {
          return -1;
        }
      });

      if (cotacao_barato.name == cotacao[0].name) {
        var cotacao_rapido = cotacao[1];
      } else {
        var cotacao_rapido = cotacao[0];
      }

      var cotacao_final = [];

      if (cidade != "São Paulo") {
        cotacao_final.push(cotacao_rapido);
        cotacao_final.push(cotacao_barato);
        this.setState({ shipping_value: cotacao_rapido });
        $("#select-shipping").val(JSON.stringify(cotacao_rapido));
        cotacao_final[0].type = "mais-rapido";
        cotacao_final[1].type = "mais-barato";
      }

      cotacao_final.push({
        name: "CLIENTE RETIRA",
        prazo_producao: 1,
        type: "gratis-cliente-retira",
        max: 1,
        min: 1,
        price: "R$ 0,00",
      });

      if (cidade == "São Paulo") {
        cotacao_final.push({
          name: "NOSSO CARRO",
          prazo_producao: 1,
          type: "gratis-nosso-carro",
          max: 1,
          min: 1,
          price: "R$ 0,00",
        });
      }

      await this.setState({ cotacao_frete: cotacao_final });
      if (this.state.data_delivery.data_shipping != undefined) {
        if (this.state.data_delivery.data_shipping.type == "transp-parceiro") {
          this.selectCustomerShipping({
            target: {
              value: JSON.stringify({
                razao_social: this.state.data_delivery.data_shipping.name,
              }),
            },
          });
        } else {
          this.setState({
            shipping_value: this.state.data_delivery.data_shipping,
          });
          $("#select-shipping").val(
            JSON.stringify(this.state.data_delivery.data_shipping)
          );
        }
      } else {
        if (cidade != "São Paulo") {
          this.selectShipping({
            target: {
              options: {
                selectedIndex: 1,
                1: { value: JSON.stringify(cotacao_final[0]) },
              },
            },
          });
        } else {
          this.selectShipping({
            target: {
              options: {
                selectedIndex: 1,
                1: {
                  value: JSON.stringify({
                    name: "NOSSO CARRO",
                    prazo_producao: 1,
                    type: "gratis-nosso-carro",
                    max: 1,
                    min: 1,
                    price: "R$ 0,00",
                  }),
                },
              },
            },
          });
        }
      }
    } catch (error) {
      this.getFreightQuote(e);
      console.log(Object.keys(error), error.message);
    }
  };

  selectCustomerShipping = async (e) => {
    var data = JSON.parse(e.target.value);

    var cotacoes = [];
    this.state.cotacao_frete.map((item) => {
      if (item.type != "transp-parceiro") {
        cotacoes.push(item);
      }
    });

    cotacoes.push({
      name: data.razao_social,
      prazo_producao: 10,
      type: "transp-parceiro",
      max: 1,
      min: 1,
      price: "R$ 0,00",
    });

    await this.setState({
      cotacao_frete: cotacoes,
      shipping_value: {
        name: data.razao_social,
        prazo_producao: 10,
        type: "transp-parceiro",
        max: 1,
        min: 1,
        price: "R$ 0,00",
      },
    });

    $("#select-shipping").val(
      JSON.stringify({
        name: data.razao_social,
        prazo_producao: 10,
        type: "transp-parceiro",
        max: 1,
        min: 1,
        price: "R$ 0,00",
      })
    );

    this.state.data_delivery.data_shipping = {
      name: data.razao_social,
      prazo_producao: 10,
      type: "transp-parceiro",
      max: 1,
      min: 1,
      price: "R$ 0,00",
    };

    this.props.updateData(this.state.data_delivery, "shipping");

    this.setState({ view_modal_shipping: false });
  };

  selectShipping = async (e) => {
    if (
      e.target.options[e.target.options.selectedIndex].value == "other-shipping"
    ) {
      await this.setState({ view_modal_shipping: true });
    } else {
      var data = JSON.parse(
        e.target.options[e.target.options.selectedIndex].value
      );
      this.state.data_delivery.data_shipping = data;
      this.props.updateData(this.state.data_delivery, "shipping");
      await this.setState({ shipping_value: data });
    }
  };

  render() {
    const returnDataShipping = [
      {
        title: "codigo_parceiro",
        field: "codigo_parceiro",
      },
      {
        title: "razao_social",
        field: "razao_social",
      },
      {
        title: "cpf_cnpj",
        field: "cpf_cnpj",
      },
    ];

    const gridShipping = [
      { title: "Nome", field: "nome_parceiro", function: "" },

      { title: "Razão social", field: "razao_social", function: "" },

      { title: "CPF / CNPJ", field: "cpf_cnpj", function: "" },

      { title: "Vendedor", field: "apelido", function: "" },
    ];
    return (
      <Box>
        <BillingShippingContainer style={{ height: "0px" }}>
          {this.state.view_modal_shipping ? (
            // <Modal
            //   closeModal={() => this.setState({ view_modal_shipping: false })}
            //   select={this.selectCustomerShipping}
            //   title_filter="PARCEIRO"
            //   call={{
            //     endpoint: ListaClientes,
            //     method: "POST",
            //     param: [
            //       { field: "texto_buscado", find: "state" },
            //       { field: "transportadora", find: "config" },
            //     ],
            //   }}
            //   config={{ transportadora: "S" }}
            //   checkboxField={returnDataShipping}
            //   grid={gridShipping}
            // />
            <ModalParceiro 
                  FecharModal={() => this.setState({ view_modal_shipping: false })}
                  seleciona={this.selectCustomerShipping}
                  title_filter={{
                    data: [
                      {
                        title: "Nome",
                        field: "nome_parceiro",
                      },
                      {
                        title: "CPFCNPJ",
                        field: "cpfcnpj_parceiro",
                      },
                      {
                        title: "CODPARC",
                        field: "codigo_parceiro",
                      },
                    ],
                  }}
                  call={{
                    endpoint: ListaClientes,
                    param: [
                      {
                        field: "nome_parceiro",
                        find: "state",
                      },
                      {
                        field: "cpfcnpj_parceiro",
                        find: "state",
                      },
                      {
                        field: "codigo_parceiro",
                        find: "state",
                      },
                      {
                        field: "transportadora",
                        find: "config",
                      },
                    ],
                  }}
                  config={{ transportadora: "S" }}
                  checkboxField={returnDataShipping}
                  grid={gridShipping}
              /> 
          ) : (
            <></>
          )}
        </BillingShippingContainer>
        <BillingShippingContentContainer>
          <TitleWithControl width={545} back={this.props.back}>
            <p>
              <strong>RECALCULAR MELHOR ENVIO</strong> QUE DESEJA PARA O FATURAMENTO
            </p>
            <h1>{this.state.index_request}</h1>
          </TitleWithControl>

          <BillingShippingContentContainerContent>
            <BillingShippingContentContainerContentShipping>
              <label>
                <span className="icon icon-60 icon-clock-orange"></span>
                <p>MAIS RÁPIDO</p>
              </label>
              <select
                id={"select-shipping"}
                onChange={(e) => this.selectShipping(e)}
              >
                {this.state.cotacao_frete.map((data) => {
                  return (
                    <option value={JSON.stringify(data)}>
                      TRANSPORTADORA: {data.name}, PREVISÃO DE{" "}
                      {data.prazo_producao} DIAS
                    </option>
                  );
                })}
                <option value={"other-shipping"}>
                  SELECIONAR OUTRA TRANSPORTADORA
                </option>
              </select>
              <p>
                {this.state.shipping_value.price != undefined
                  ? this.state.shipping_value.price
                  : "R$ 0,00"}
              </p>
            </BillingShippingContentContainerContentShipping>
          </BillingShippingContentContainerContent>
          <Center>
            
            <Box marginRight="10px">
              <Tag
                fontSize="18px"
                fontFamily="Akrobat"
                bgColor="transparent"
              >
                Valor real do frete
              </Tag>
              <br/>
              <InputGroup>
                <InputLeftAddon
                    children='R$'
                    bgColor="#ff7e00"
                    color="white"
                    fontFamily="Akrobat SemiBold"
                  />
                <Input  width={140}
                        height="40px"
                        value={isNaN(parseFloat(this.state.data_proposal.valor_cotacao_frete)) ? 0 : parseFloat(this.state.data_proposal.valor_cotacao_frete)}
                        onChange={(e)=>this.props.updateDataProposal(e,'valor_cotacao_frete')}/>
              </InputGroup>
            </Box>
            <Box marginRight="10px">
              <Tag
                  fontSize="18px"
                  fontFamily="Akrobat"
                  bgColor="transparent"
              >
                Valor do frete + 30%
              </Tag>
              <br/>
              <InputGroup>
                <InputLeftAddon children='R$' bgColor="#ff7e00" color="white" fontFamily="Akrobat SemiBold"/>
                <Input  width={140}
                        height="40px"
                        value={isNaN(parseFloat(parseFloat(this.state.data_proposal.valor_cotacao_frete) + ((parseFloat(this.state.data_proposal.valor_cotacao_frete)*30)/100))) ? 0 : parseFloat(parseFloat(this.state.data_proposal.valor_cotacao_frete) + ((parseFloat(this.state.data_proposal.valor_cotacao_frete)*30)/100))}/>
              </InputGroup>
            </Box>
            <Box marginRight="10px">
              <Tag
                  fontSize="18px"
                  fontFamily="Akrobat"
                  bgColor="transparent"
              >
                Cód. da cotação
              </Tag>
              <br/>
              <InputGroup>
                <Input width={140} height="40px" value={this.state.data_proposal.numero_cotacao_frete} onChange={(e)=>this.props.updateDataProposal(e,'numero_cotacao_frete')}/>
              </InputGroup>
            </Box>
            <Box marginRight="10px">
              <Tag
                  fontSize="18px"
                  fontFamily="Akrobat"
                  bgColor="transparent"
              >
                Destaca Nota
              </Tag>
              <br/>
              <InputGroup>
                <InputLeftAddon children='R$' bgColor="#ff7e00" color="white" fontFamily="Akrobat SemiBold"/>
                <Input width={140} height="40px" value={this.state.data_proposal.valor_frete} onChange={(e)=>this.props.updateDataProposal(e,'valor_frete')}/>
              </InputGroup>
            </Box>
            
          </Center>
          <ButtonContinue onClick={this.props.continue}>
            <ResumeShipping
              total_value={this.state.total_value}
              value_shipping={this.state.shipping_value}
            />
          </ButtonContinue>
        </BillingShippingContentContainer>
      </Box>
    );
  }
}

function ResumeShipping(data) {
  return (
    <BillingShippingContentContainerContentShippingResume>
      <BillingShippingContentContainerContentShippingResumeContent>
        <p>
          <strong>Resumo do faturamento:</strong> 1
        </p>
        <p>
          <strong>Valor total produto:</strong>{" "}
          {data.total_value.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })}
        </p>
        <p>
          <strong>Valor total ST:</strong> R$ 0,00
        </p>
        {data.value_shipping.price != undefined ? (
          <p>
            <strong>Valor do frete:</strong> {data.value_shipping.price}
          </p>
        ) : (
          "R$ 0,00"
        )}
      </BillingShippingContentContainerContentShippingResumeContent>
    </BillingShippingContentContainerContentShippingResume>
  );
}

export default BillingShipping;
